import type { Shop } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'

export interface AllShopsQuery {
  allShops?: {
    edges: Shop[]
    pageInfo: PageInfo
  }
}

export interface AllShopsVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
}

export const GQL_QUERY_ALL_SHOPS = gql`
  query(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allShops(
      filter: $filter
      sort: $sort
      pager: $pager) {
        edges {
          id
          xid
          slug
          name
          status
          phone

          minOrderCost
          
          workingHours
          tzOffset
          
          address
          shopGeoPoint {
            latitude
            longitude
          }
          shopOpenTime
          shopCloseTime

          tg_chat_id
          vkMaxChatId

          slotPlans {
            id
            shop_id
            weekDay
            slotStartTime
            slotFinishTime
            ordersLimit
            positionsLimit
          }

          is_serving_wholesale
          is_serving_retail
        }
        pageInfo {
            ${SHORTCUT_PAGE_INFO_FIELDS}
        }
      }
    }
`

export const useFetchAllShops = (variables?: AllShopsVariables) =>
  useQuery<AllShopsQuery, AllShopsVariables>(GQL_QUERY_ALL_SHOPS, {
    variables,
    fetchPolicy: 'network-only'
  })
